import { render, staticRenderFns } from "./player.vue?vue&type=template&id=1e0d697e&scoped=true"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"
import style0 from "./player.vue?vue&type=style&index=0&id=1e0d697e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d697e",
  null
  
)

export default component.exports